export default __webpack_public_path__ + "static/media/ht.dd2f262a.svg";